// removed by extract-text-webpack-plugin
module.exports = {"form":"c-AccountDetailsForm__form","fields":"c-AccountDetailsForm__fields","wrapper":"c-AccountDetailsForm__wrapper","button":"c-AccountDetailsForm__button","points":"c-AccountDetailsForm__points"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/AccountDetailsForm/AccountDetailsForm.scss
// module id = 724
// module chunks = 0